import React from "react";
import "../styles/Gallery.css";

const Gallery = () => {
  const galleryImages = [
    {
      id: 1,
      src: "https://images.pexels.com/photos/7446676/pexels-photo-7446676.jpeg?auto=compress&cs=tinysrgb&w=800",
      alt: "Professional dermatologist treatment",
      title: "Expert Care"
    },
    {
      id: 2,
      src: "https://customer-assets.emergentagent.com/job_aura-aesthetics-2/artifacts/n4qihrw9_emma3.png",
      alt: "Blue light facial treatment at Aura Aesthetics",
      title: "Advanced Treatments"
    },
    {
      id: 3,
      src: "https://customer-assets.emergentagent.com/job_aura-aesthetics-2/artifacts/j08ovn6o_Shar.jpg",
      alt: "Professional facial device treatment",
      title: "Advanced Technology"
    },
    {
      id: 4,
      src: "https://customer-assets.emergentagent.com/job_aura-aesthetics-2/artifacts/32d9tgxs_Watzi.jpg",
      alt: "Aesthetic injectable treatment",
      title: "Expert Precision"
    }
  ];

  return (
    <section className="gallery-section section-padding-small">
      <div className="container">
        <div className="gallery-header">
          <span className="body-small gallery-label">Our Work</span>
          <h2 className="hero-medium">Celebrating Beauty in All Forms</h2>
          <p className="body-large">
            Every skin tone, every individual, every story matters. Our treatments are designed for everyone.
          </p>
        </div>
        <div className="gallery-grid">
          {galleryImages.map((image) => (
            <div key={image.id} className="gallery-item">
              <div className="gallery-image">
                <img src={image.src} alt={image.alt} />
                <div className="gallery-overlay">
                  <span className="heading-3">{image.title}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
